import { render } from "./WaterQualityData.vue?vue&type=template&id=4c6db96f"
import script from "./WaterQualityData.vue?vue&type=script&lang=js"
export * from "./WaterQualityData.vue?vue&type=script&lang=js"

import "./WaterQualityData.vue?vue&type=style&index=0&id=4c6db96f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__